(function() {
    'use strict';

    angular.module('format')
        .controller('FormatGroupListController', FormatGroupListController);

    FormatGroupListController.$inject = ['$state', 'notificationSrvc', 'formatGroupDataSrvc', 'formatGroupSrvc', 'formatGroupMessagesConst', 'lodashService', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'formatGroupPermissionsConst', 'filterQuerySrvc'];

    function FormatGroupListController($state, notificationSrvc, formatGroupDataSrvc, formatGroupSrvc, formatGroupMessagesConst, lodashService, datatableDefaultPageSizeValueConst, checkSearchSrvc, formatGroupPermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.groupsRows = [];
        self.groupsCols = [{
            title: 'ID',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nazwa',
            value: 'name_pl',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.modelPermissions = formatGroupPermissionsConst;

        self.searchQuery = {
            pk: null,
            name: null,
            ordering: null
        };

        self.onReorder = onReorder;
        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;
        self.onClick = onClick;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getGroups();
        }

        function getGroups(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    pk: self.searchQuery.pk,
                    name: self.searchQuery.name,
                    ordering: self.searchQuery.ordering
                };
            }
            return formatGroupDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.groupsRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getGroups);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onReorder(row, newPos) {
            return formatGroupDataSrvc.update({
                pk: row.pk
            }, {
                position: newPos
            });
        }

        function onCreate() {
            $state.go('layout.formatGroup.create');
        }

        function onEdit(row) {
            $state.go('layout.formatGroup.update', { pk: row.pk });
        }

        function onClick(row) {
            $state.go('layout.formatGroup.detail', { pk: row.pk });
        }

        function onDelete(row) {
            return formatGroupSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", formatGroupMessagesConst.delete);
                lodashService.remove(self.groupsRows, { pk: row.pk });
                return response;
            }, function(response) {
                notificationSrvc.notification("error", response.data.data.non_field_errors[0]);
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getGroups();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getGroups();
        }
    }
})();
